import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';

@Injectable({
  providedIn: 'root',
})
export class TimetableService {
  public selectedYear = null;
  public yearsLoaded$ = new BehaviorSubject<number[]>([]);
  public yearChanged$ = new BehaviorSubject<number>(-1);
  private readonly organisationStartYear = '2020'; // Todo: Read this from the database.

  constructor() {
    this.getYearsSinceOrganisationStart();
  }

  private getYearsSinceOrganisationStart(): void {
    let startDate = new Date(this.organisationStartYear);
    const currentDate = new Date();

    const yearNumbers: number[] = [];
    while (startDate.getFullYear() <= currentDate.getFullYear()) {
      yearNumbers.push(startDate.getFullYear());
      startDate = DateTimeHelper.addYears(startDate, 1);
    }

    this.yearsLoaded$.next(yearNumbers);
  }
}
